// Drawing tour areas by hand: a lasso picks scans on the plan, and picked
// scans are moved into one area (a scan is in one drawn area at most).

import type { TourAreaGroup } from './tourAreas';

export function pointInPolygon(x: number, y: number, poly: Array<[number, number]>): boolean {
  let inside = false;
  for (let i = 0, j = poly.length - 1; i < poly.length; j = i++) {
    const [xi, yi] = poly[i], [xj, yj] = poly[j];
    if ((yi > y) !== (yj > y) && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi) inside = !inside;
  }
  return inside;
}

// The picked scans join `targetId` and leave every other area.
export function assignScans(groups: TourAreaGroup[], stationIds: string[], targetId: string): TourAreaGroup[] {
  const picked = new Set(stationIds);
  return groups.map((g) => {
    const rest = g.stationIds.filter((id) => !picked.has(id));
    return g.id === targetId ? { ...g, stationIds: [...rest, ...stationIds] } : { ...g, stationIds: rest };
  });
}

export function removeScans(groups: TourAreaGroup[], stationIds: string[]): TourAreaGroup[] {
  const picked = new Set(stationIds);
  return groups.map((g) => ({ ...g, stationIds: g.stationIds.filter((id) => !picked.has(id)) }));
}

// "Area 1", "Area 2"…: the first not taken.
export function nextAreaName(groups: TourAreaGroup[]): string {
  const taken = new Set(groups.map((g) => g.name.trim().toLowerCase()));
  for (let n = 1; ; n++) if (!taken.has(`area ${n}`)) return `Area ${n}`;
}

// "a1", "a2"…: ids only need to differ within the project.
export function nextGroupId(groups: TourAreaGroup[]): string {
  let n = 0;
  for (const g of groups) {
    const m = /^a(\d+)$/.exec(g.id);
    if (m) n = Math.max(n, Number(m[1]));
  }
  return `a${n + 1}`;
}

export function newArea(groups: TourAreaGroup[], stationIds: string[]): { groups: TourAreaGroup[]; id: string } {
  const id = nextGroupId(groups);
  const moved = removeScans(groups, stationIds);
  return { groups: [...moved, { id, name: nextAreaName(groups), stationIds: [...stationIds] }], id };
}
